module.exports = __webpack_public_path__ + "5dac426eaf3baec5cada5bac61043a36.woff2";